import { Node } from "@tiptap/core";
import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";
import { ArrowUpRight, Trash2 } from "lucide-react";
import { TONES } from "@/components/admin/posts/extensions/Callout";
import { cn } from "@/lib/utils";

const CtaView = ({ node, updateAttributes, deleteNode, selected }) => (
  <NodeViewWrapper as="div" data-type="cta" data-tone={node.attrs.tone} className={cn("hk-cta", selected && "is-selected")} data-testid="editor-cta">
    <span className="hk-cta-button" data-drag-handle>{node.attrs.label || "Les meir"} <ArrowUpRight className="h-4 w-4" /></span>
    <div className="hk-inline-form" contentEditable={false} data-testid="editor-cta-form">
      <input value={node.attrs.label} onChange={(e) => updateAttributes({ label: e.target.value })} placeholder="Tekst på knappen" aria-label="Tekst på knappen" data-testid="editor-cta-label" />
      <input value={node.attrs.href} onChange={(e) => updateAttributes({ href: e.target.value })} placeholder="Lenkje – t.d. /arrangement eller https://…" aria-label="Lenkje" className="font-mono" data-testid="editor-cta-href" />
      <span className="hk-seg">{TONES.map((t) => <button key={t.v} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => updateAttributes({ tone: t.v })} className={cn(node.attrs.tone === t.v && "is-on")}>{t.l}</button>)}</span>
      <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={deleteNode} className="is-danger" title="Fjern knappen" aria-label="Fjern knappen" data-testid="editor-cta-remove"><Trash2 className="h-3.5 w-3.5" /></button>
    </div>
  </NodeViewWrapper>
);

/** <div data-type="cta" data-tone><a href>Label</a></div> – a big friendly button in the article. */
export const Cta = Node.create({
  name: "cta",
  group: "block",
  atom: true,
  draggable: true,
  addAttributes() {
    return {
      href: { default: "/arrangement", parseHTML: (el) => el.querySelector("a")?.getAttribute("href") || "/arrangement" },
      label: { default: "Kjøp billettar", parseHTML: (el) => el.querySelector("a")?.textContent?.trim() || "Les meir" },
      tone: { default: "ink", parseHTML: (el) => el.getAttribute("data-tone") || "ink" },
    };
  },
  parseHTML() { return [{ tag: 'div[data-type="cta"]' }]; },
  renderHTML({ node }) {
    const href = (node.attrs.href || "").trim() || "/arrangement";
    return ["div", { "data-type": "cta", "data-tone": node.attrs.tone }, ["a", /^https?:\/\//i.test(href) ? { href, target: "_blank", rel: "noopener noreferrer" } : { href }, node.attrs.label || "Les meir"]];
  },
  addNodeView() { return ReactNodeViewRenderer(CtaView); },
});
